module.exports = __webpack_public_path__ + "img/discover.578ec54a.svg";